export * from "ce/api/OrganizationApi";
import { OrganizationApi as CE_OrganizationApi } from "ce/api/OrganizationApi";

class OrganizationApi extends CE_OrganizationApi {}

export default OrganizationApi;
